import { useTranslation } from 'react-i18next';
import styles from './ShopifyTileComponent.module.css';
import { Text } from '@shopify/polaris';

export interface ShopifyTileComponentProps {
    titleKey: string;
    descriptionKey: string;
    values?: Record<string, string | number>;
    buttonKey?: string;
    buttonOnClick?: () => void;
    content?: React.ReactNode;
    completed?: boolean;
}

export const ShopifyTileComponent: React.FC<ShopifyTileComponentProps> = ({
    titleKey,
    descriptionKey,
    values,
    buttonKey,
    buttonOnClick,
    content,
    completed,
}) => {
    const { t } = useTranslation('translation');

    return (
        <div className={`${styles.wrapper} ${completed ? styles.completed : ''}`}>
            <div className={styles.header}>
                <Text as={'h3'} variant={'headingMd'}>
                    {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                    {t(titleKey as any, values) as string}
                </Text>
                <Text as={'p'} variant={'bodyMd'}>
                    {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                    {t(descriptionKey as any, values) as string}
                </Text>
            </div>
            <div className={styles.container}>{content}</div>
            {(!!buttonKey || completed) && (
                <div className={styles.footer}>
                    {!!buttonKey && (
                        <s-button onClick={buttonOnClick} variant={completed ? 'secondary' : undefined}>
                            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                            {t(buttonKey as any) as string}
                        </s-button>
                    )}
                    {completed && (
                        <s-badge tone={'success'} icon={'check'}>
                            {t('SHOPIFY_TILE_BANNERS.COMPLETED') as string}
                        </s-badge>
                    )}
                </div>
            )}
        </div>
    );
};
